import { Component, computed, EventEmitter, input, Output } from '@angular/core';
import { ScheduleEvent } from '../../../shared/models/ScheduleModels';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { EventDetailsDialogComponent, EventDetailsDialogResult } from '../../../shared/components/event-details-dialog/event-details-dialog.component';

@Component({
  selector: 'app-generic-event',
  imports: [DatePipe],
  templateUrl: './generic-event.component.html',
  styleUrl: './generic-event.component.css'
})
export class GenericEventComponent {

  constructor(private dialog: MatDialog) {}

  Event = input<ScheduleEvent>();
  @Output() deleteEvent = new EventEmitter<void>();

  localEventStart = computed(() => {
    const event = this.Event();
    if (!event?.EventStartUTC) return new Date();
    return this.convertUTCToLocal(event.EventStartUTC);
  });

  private convertUTCToLocal(utcDate: any): Date {
    if (!utcDate) return new Date();

    // If it's already a Date, return it
    if (utcDate instanceof Date) return utcDate;

    // If it's a string, ensure it's treated as UTC
    const dateStr = utcDate.toString();
    // Add 'Z' if not present to indicate UTC
    if (!dateStr.endsWith('Z') && !dateStr.includes('+')) {
      return new Date(dateStr + 'Z');
    }
    return new Date(dateStr);
  }

  openEventDetails(): void {
    const event = this.Event();
    if (!event) {
      return;
    }

    const dialogRef = this.dialog.open(EventDetailsDialogComponent, {
      maxWidth: '520px',
      width: '92vw',
      panelClass: 'event-details-dialog',
      data: event,
    });

    dialogRef.afterClosed().subscribe((result: EventDetailsDialogResult | undefined) => {
      if (result?.action === 'delete') {
        this.deleteEvent.emit();
      }
    });
  }
}
